import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RunIdSchema } from "../primitives/ids.js";
/**
 * tier0-minimal-dk-bundle.v1.0 — required relative paths under export root (D-028).
 * Worker must emit exactly these paths (files may be minimal JSON/text; no PII in approval-records).
 */
export const Tier0MinimalDepartureKitRelativePaths = [
    "departure-kit/README.md",
    "departure-kit/businessgraph-snapshot.json",
    "departure-kit/artifact-manifest.json",
    "departure-kit/quality-gate-result.json",
    "departure-kit/approval-records/tier0-stub.json",
    "departure-kit/handoff-notes.md",
];
/** Non-PII opaque approval stub entry (Guardian warning: no secrets / no raw debug). */
export const Tier0ApprovalRecordStubEntrySchema = z
    .object({
    kind: z.string().min(1),
    opaqueRef: z.string().min(1),
    recordedAt: z.string().datetime(),
})
    .strict();
export const Tier0ApprovalRecordsStubFileSchema = z
    .object({
    schemaVersion: z.literal("tier0-approval-records-stub.v1.0"),
    entries: z.array(Tier0ApprovalRecordStubEntrySchema).min(1),
})
    .strict();
/** ties site + DK folder for integrity hashing */
export const Tier0ExportBundleManifestV1Schema = z
    .object({
    schemaVersion: z.literal("tier0-export-bundle-manifest.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    runId: RunIdSchema,
    artifactSetHash: z.string().min(1),
    /** GN-001 — binds export bundle to version-pinned build manifest identity */
    buildManifestIdentityHash: z.string().min(1),
    siteManifestRelativePath: z.literal("site/manifest.json"),
    departureKitPaths: z.array(z.string()).min(1),
})
    .strict();
//# sourceMappingURL=tier0-minimal-departure-kit.js.map